<div data-testid="teacher-remediation-modal">
  <div class="modal-heading modal-heading-1">
    <div class="label_name">
      {{ logicalError.SubjectName }}
    </div>
  </div>
  <div class="modal-body remediation-modal">
    <div *ngIf="show">
        <p class="spacer-md mb-3" [innerHTML]="'TEACHER_REMEDIATION_MODAL.INSTRUCTION' | translate"></p>
      <div *ngIf="logicalError.StruggleReasons" class="well spacer-sm">
        <kh-img path="question-mark.png" class="remediation-modal__icon"></kh-img>
        <b>{{ 'TEACHER_REMEDIATION_MODAL.WHY_SOME_STUDENTS_STRUGGLE' | translate }}</b>
        <ol class="text-smp">
          <li *ngFor="let struggleReason of logicalError.StruggleReasons" [innerHtml]="struggleReason"></li>
        </ol>
      </div>
      <div class="center spacer-md" *ngIf="logicalError.Documents.length">
        <button class="view-supports-button" (click)="goToTeacherStudentGapDetail(logicalError.LogicalErrorId)">
          {{ 'TEACHER_REMEDIATION_MODAL.VIEW_TEACHER_SUPPORTS' | translate }}
        </button>
      </div>
  
      <div class="center spacer-md">
        <a class="cursor text-lg" (click)="closeModal()" data-testid="close-button">{{ 'TEACHER_REMEDIATION_MODAL.CLOSE' | translate }}</a>
      </div>
    </div>
  </div>
</div>
